import { render, staticRenderFns } from "./UiPill.vue?vue&type=template&id=c6fb8e9c&"
import script from "./UiPill.vue?vue&type=script&lang=js&"
export * from "./UiPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports